<script>
    import Transition from "../components/Transition.svelte";
    import {onMount} from "svelte";
    import {perksUrl} from "../urls";
    import {customFetch} from "../customFetch";
    import {notifications} from "../notifications";
    import StraightTable from "../components/StraightTable.svelte";
    import {
        dropdownView,
        editableImageView,
        editableBigIconView,
        valueView,
        saveRows, labelView
    } from "../tableUtils";

    onMount(init);

    let originalRows = {};
    let rows = [];

    async function load() {
        try {
            let response = await customFetch(perksUrl()); // Changed from locomotivesUrl to perksUrl
            let data = await response.json();
            for (let i = 0; i < data.length; i++) {
                data[i].UpdatedAt = new Date(data[i].UpdatedAt)
                data[i].Changes = new Set();
                originalRows[data[i].ID] = JSON.parse(JSON.stringify(data[i]));
            }
            rows = data;
        } catch (e) {
            notifications.danger(
                `Error loading perks: ${e.message}` // Changed error message
            );
        }
    }

    function init() {
        load();
    }

    let perkTypes = {
        "Steward": 1,
        "Switchman": 2,
        "Loader": 3,
        "Freighterman": 4,
        "Ghostman": 5,
        "Salesman": 6,
        "Engineer": 7,
    }

    async function save(e) {
        const rows = e.detail.data;
        let fields = columns.map(elem => elem.field);
        await saveRows(rows, fields, perksUrl());
        await load();
    }

    let columns = [
        {title: 'ID', field: 'ID', sortable: true, defaultValue: null, editView: labelView},
        {title: 'Perk Type', field: 'Type', sortable: false, defaultValue: 1, editView: dropdownView(perkTypes)},
        {title: 'Value', field: 'Value', sortable: false, defaultValue: 0, editView: valueView("number", 0.01, 0, 100)},
        {title: 'Icon', field: 'NewIcon', sortable: false, defaultValue: null, editView: editableImageView()},
        {title: 'Portrait', field: 'NewPortrait', sortable: false, defaultValue: null, editView: editableBigIconView("PortraitData", "NewPortrait")},
        {title: 'DisabledPortrait', field: 'NewDisabledPortrait', sortable: false, defaultValue: null, editView: editableBigIconView("DisabledPortraitData", "NewDisabledPortrait")},
        {title: 'Epoch', field: 'Epoch', sortable: false, defaultValue: 1, editView: valueView("number", 1, 0, 5)},
        {title: 'Column', field: 'Column', sortable: true, defaultValue: 1, editView: valueView("number", 1, 0)},
        {title: 'Order', field: 'Order', sortable: true, defaultValue: 0, editView: valueView("number", 1, 0)},
        {title: 'Price', field: 'Price', sortable: false, defaultValue: 1, editView: valueView("number", 1, 0)},
        {title: 'Name', field: 'Name', sortable: false, defaultValue: 'Name', editView: valueView("text")},
        {title: 'Info', field: 'Info', sortable: false, defaultValue: 'Info', editView: valueView("text")},
    ];

</script>

<Transition>
    <StraightTable data={rows} {columns} on:change={save}/>
</Transition>